import { useData } from "../runtime/provider";
import { usePlayerActions } from "@utils/player/core/usePlayer";
import { useCallback, useEffect } from "react";

import { useNavigationStore } from "@utils/navigation/useNavigationStore";

export const useReloadHandler = (componentName: string) => {
  const session = useData();
  const playerActions = usePlayerActions();

  const reloadApp = useCallback(async () => {
    await Promise.all([
      session.queryClient.invalidateQueries().then(() => {
        console.log(
          `::useReloadHandler - queries invalidated for ${componentName}`,
        );
      }),

      Promise.resolve().then(() => {
        playerActions.reset();
        console.log(`::useReloadHandler - player reset for ${componentName}`);

        // IMPORTANT (web + auth flows):
        // `reset()` clears `foryouQueue`, and the auth state may already be stable
        // (no further onAuthStateChanged event) so the feed can remain blank.
        // Re-bootstrap ForYou immediately after a reset.
        playerActions
          .loadForYouInitial({ forceReplace: true, resetCursors: true })
          .catch(console.error);
      }),
    ]);
    useNavigationStore.setState({ reload: undefined });
  }, [componentName]);

  const reload = useNavigationStore((state) => state.reload);

  useEffect(() => {
    if (reload === "true") {
      reloadApp().catch((e) => {
        console.error(
          `::useReloadHandler - error reloading for ${componentName}`,
          e,
        );
      });
    }
  }, [reloadApp, reload, componentName]);
};
